import { StyleSheet, Platform } from 'react-native';

import { colors } from '@styles/colors';

import { createStyles } from '@lib/style';

const commentHeight = 111;
const cardBackgroundColor = '#FFF';

export const styles = createStyles(() => ({
  root: {
    //flex: 1,
    marginVertical: '5%',
  },
  header: {
    marginBottom: 20,
    fontSize: 20,
    fontWeight: '600',
    color: colors.Gray_1,
  },
  cards: {
    flexDirection: 'row',
    minHeight: 75,
    marginBottom: 25,
  },
  card: {
    flexBasis: 1,
    flexGrow: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 8,
    paddingTop: 25,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: cardBackgroundColor,
    backgroundColor: cardBackgroundColor,
    ...Platform.select({
      ios: {
        shadowColor: 'gray',
        shadowOffset: { width: 3, height: 3 },
        shadowOpacity: 0.7,
        shadowRadius: 2,
      },
      android: { elevation: 6 },
    }),
    paddingHorizontal: 30,
    paddingVertical: 15,
  },
  cardMiddle: {
    marginHorizontal: 10,
  },

  cardActive: {
    borderColor: colors.Green_2_Prom,
  },
  cardIcon: {
    marginBottom: 7,
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    lineHeight: 24,
    color: colors.Gray_1,
  },
  cardDetail: {
    fontSize: 11,
    fontWeight: '400',
    //lineHeight: 21,
    color: colors.Gray_1,
    marginTop: 5,
  },
  comment: {
    height: commentHeight,
  },
  rowBoxes: {
    flexDirection: 'row',
    //width: '90%',
    marginTop: '2%',
  },
  freeSpaceWidth: { width: '3%' },
  freeSpaceHeight: { height: 5 },
  containerBox: {
    flex: 1,
    flexDirection: 'column',
    padding: 0,
    height: 90,
  },
  titleInBox: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
    width: '80%',
  },
  titleOrder: {
    color: '#000000',
  },
  titleCheck: {
    fontSize: 16,
    fontWeight: 'normal',
    color: '#FFFFFF',
  },
  titleDetail: {
    marginTop: 5,
    fontSize: 10,
    fontWeight: 'normal',
    color: '#C0EFDC',
  },
  iconContainer: {
    //flex: 4.65,
    position: 'absolute',
    top: 2,
    right: 2,
    //backgroundColor: 'pink',
    //alignItems: 'flex-end',
  },
  linearBox: {
    paddingVertical: 10,
  },
}));
